export const CHANNELS = [
  {
    id: 'EMAIL',
    label: 'EMAIL',
  },
  {
    id: 'SMS',
    label: 'SMS',
  },
  { id: 'BOTH', label: 'BOTH' },
];
